export class Navigation {
  public static NEW: number = -9;

  topic: string;
  id: string;
  action: string;
  fragmentTopic: string | null;
  fragmentId: string | null;

  constructor(
    topic: string,
    id: string,
    tab: string,
    fragmentTopic: string | null,
    fragmentId: string | null
  ) {
    this.topic = topic;
    this.id = id;
    this.action = tab;
    this.fragmentTopic = fragmentTopic;
    this.fragmentId = fragmentId;
  }
}
